import { render } from "./SliderTwo.vue?vue&type=template&id=5cfa4a40"
import script from "./SliderTwo.vue?vue&type=script&lang=js"
export * from "./SliderTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__